<template>
  <div class="doctor-labor-info-container">
    <div>
      <div class="doctor-labor-info-title global-center">完善劳务信息</div>
      <div>
        <MeetMenu
          customStyle="padding-left:20px;padding-right:20px;font-size:16px;"
          icon="message.png"
          title="基本信息"
        >
        </MeetMenu>
        <div class="doctor-labor-info-main">
          <div class="doctor-labor-info-block doctor-labor-info-name">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['name'],
                  'doctor-labor-info-blue': doctorInfo['name'],
                }"
                >*</span
              >姓名
            </div>
            <div class="global-input doctor-labor-info-value">
              <div class="doctor-labor-info-name-block">
                <el-input
                  v-model.trim="doctorInfo.name"
                  placeholder="请输入姓名"
                ></el-input>
                <div class="global-mask"></div>
              </div>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['hospital'],
                  'doctor-labor-info-blue': doctorInfo['hospital'],
                }"
                >*</span
              >医院
            </div>
            <div class="global-input doctor-labor-info-value">
              <el-input
                v-model.trim="doctorInfo.hospital"
                placeholder="请输入医院名称"
              ></el-input>
              <div class="global-mask"></div>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['department'],
                  'doctor-labor-info-blue': doctorInfo['department'],
                }"
                >*</span
              >专家科室
            </div>
            <div class="global-input doctor-labor-info-value">
              <el-input
                v-model.trim="doctorInfo.department"
                placeholder="请输入专家科室"
              ></el-input>
              <div class="global-mask"></div>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['phone'],
                  'doctor-labor-info-blue': doctorInfo['phone'],
                }"
                >*</span
              >手机号码
            </div>
            <div class="global-input doctor-labor-info-value">
              <el-input
                v-model.trim="doctorInfo.phone"
                @input="changeNumber('phone')"
                placeholder="请输入手机号码"
                clearable
              ></el-input>
              <div class="global-mask"></div>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['id_card_number'],
                  'doctor-labor-info-blue': doctorInfo['id_card_number'],
                }"
                >*</span
              >身份证号
            </div>
            <div class="global-input doctor-labor-info-value">
              <el-input
                v-model.trim="doctorInfo.id_card_number"
                @input="changeIdNumber('id_card_number')"
                placeholder="请输入身份证号"
                clearable
              ></el-input>
            </div>
          </div>

          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['id_card_front'],
                  'doctor-labor-info-blue': doctorInfo['id_card_front'],
                }"
                >*</span
              >身份证照片
            </div>
            <div
              class="global-text-select doctor-labor-info-value doctor-job-select"
            >
              <div
                class="doctor-labor-info-audit-status"
                v-if="
                  doctorInfo.id_card_front &&
                  doctorInfo.id_card_reverse &&
                  doctorInfo.id_card_ocr_status === 0
                "
              >
                身份证审核中
              </div>
              <div
                class="doctor-labor-info-audit-status"
                v-if="doctorInfo.id_card_ocr_status === 2"
              >
                身份证审核失败，失败原因：{{ doctorInfo.id_card_ocr_reason }}
              </div>

              <div
                :style="IDCardHeight"
                style="border: none;"
                ref="idCardFront"
                class="global-center doctor-labor-info-select"
                v-if="isShowField('id_card_front')"
                @click="selectIDCardWay('id_card_front')"
              >
                <CustomImage :src="doctorInfo.id_card_front"></CustomImage>
              </div>
              <div
                :style="IDCardHeight"
                style="border: none;"
                ref="idCardFront"
                class="global-center doctor-labor-info-select"
                v-else
                @click="selectIDCardWay('id_card_front')"
              >
                <img
                  style="width: 100%; height: 100%;"
                  :src="require(`@/assets/images/expert/front.png`)"
                  v-if="!isShowUploaded('id_card_front')"
                  alt=""
                />
                <span v-if="isShowUploaded('id_card_front')">已上传</span>
              </div>
              <div
                :style="IDCardHeight"
                style="border: none;"
                class="global-center doctor-labor-info-select"
                v-if="isShowField('id_card_reverse')"
                @click="selectIDCardWay('id_card_reverse')"
              >
                <CustomImage :src="doctorInfo.id_card_reverse"></CustomImage>
              </div>
              <div
                :style="IDCardHeight"
                style="border: none;"
                class="global-center doctor-labor-info-select"
                v-else
                @click="selectIDCardWay('id_card_reverse')"
              >
                <img
                  style="width: 100%; height: 100%;"
                  :src="require(`@/assets/images/expert/reverse.png`)"
                  v-if="!isShowUploaded('id_card_reverse')"
                  alt=""
                />
                <span v-if="isShowUploaded('id_card_reverse')">已上传</span>
              </div>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['bank_name'],
                  'doctor-labor-info-blue': doctorInfo['bank_name'],
                }"
                >*</span
              >银行（示例：交通银行）
            </div>
            <div
              class="global-input global-text-select doctor-labor-info-value"
            >
              <el-select
                v-model="doctorInfo.bank_name"
                filterable
                allowcreate
                placeholder="请选择银行"
              >
                <el-option
                  v-for="(item, index) in config.banks"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['bank_province'],
                  'doctor-labor-info-blue': doctorInfo['bank_province'],
                }"
                >*</span
              >开户行所在省份（示例：湖北）
            </div>
            <div
              class="global-input global-text-select doctor-labor-info-value"
            >
              <el-select
                v-model="doctorInfo.bank_province"
                placeholder="请选择开户行所在省份"
                @change="changeProvince()"
              >
                <el-option
                  v-for="(item, index) in provinces"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['bank_city'],
                  'doctor-labor-info-blue': doctorInfo['bank_city'],
                }"
                >*</span
              >开户行所在城市（示例：武汉）
            </div>
            <div
              class="global-input global-text-select doctor-labor-info-value"
            >
              <el-select
                v-model="doctorInfo.bank_city"
                placeholder="请选择开户行所在城市"
              >
                <el-option
                  v-for="(item, index) in citys"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['bank_name_point'],
                  'doctor-labor-info-blue': doctorInfo['bank_name_point'],
                }"
                >*</span
              >开户银行（xx支行/xx营业部）
            </div>
            <div class="global-input doctor-labor-info-value">
              <el-input
                v-model.trim="doctorInfo.bank_name_point"
                placeholder="请输入开户银行"
              ></el-input>
            </div>
          </div>
          <div class="doctor-labor-info-block">
            <div class="doctor-labor-info-key">
              <span
                :class="{
                  'doctor-labor-info-red': !doctorInfo['bank_number'],
                  'doctor-labor-info-blue': doctorInfo['bank_number'],
                }"
                >*</span
              >银行账号
            </div>
            <div class="global-input doctor-labor-info-value">
              <el-input
                v-model.trim="doctorInfo.bank_number"
                @input="changeNumber('bank_number')"
                placeholder="请输入银行账号"
                clearable
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="doctor-labor-info-block global-center doctor-labor-info-button-group"
    >
      <CustomButton
        class="submit doctor-labor-info-submit"
        type="primary"
        @click.native="doCommit()"
        round
      >
        <img
          class="doctor-submit-icon"
          :src="require(`@/assets/images/icon/submit-doctor.png`)"
          alt=""
        />
        <span>提交信息</span>
      </CustomButton>
    </div>
    <easyCamera v-if="isUploadIDCard" :maskSrc="cameraMask" :photoName="photoName" @doSure="saveIDCard"></easyCamera>
    <image-cropper
      @closeWin="closeWin"
      @receiveData="receiveData"
      ref="imageCropper"
      :CropWidth="getCropperCfg().cropWidth"
      :CropHeight="getCropperCfg().cropHeight"
      :flexScale="getCropperCfg().flexScale"
      :MaxSize="getCropperCfg().MaxSize"
      :isShowHeadimgCalibration="getCropperCfg().isShowHeadimgCalibration"
      :uploadUrl="getCropperCfg().uploadUrl"
      v-if="cropperManager.url && cropperManager.resetFile"
    ></image-cropper>

    <input
      type="file"
      v-show="false"
      v-if="resetFile"
      @change="changeFile"
      ref="selectFile"
    />
  </div>
</template>
<script>
import ItemScroll from "@/components/unit/ItemScroll";
import ImageCropper from "@/components/unit/ImageCropper";
import CustomImage from "@/components/unit/CustomImage.vue";
import CustomButton from "@/components/unit/CustomButton.vue";
import easyCamera from "@/components/unit/easyCamera.vue";
import uploads from "@/common/uploads";
import MeetMenu from "@/components/page/meet/components/menu";
import login from "@/components/page/meet/components/login";
import uploadIdCardExample from "@/components/page/doctor/uploadIdCardExample";
import MyPopup from "@/components/unit/PagePopup.js";
import { Delete } from "@element-plus/icons";
export default {
  name: "doctorInfo",
  mixins: [login,uploadIdCardExample],
  components: {
    ItemScroll,
    ImageCropper,
    CustomButton,
    CustomImage,
    easyCamera,
    Delete,
    MeetMenu,
  },

  data() {
    return {
      config: {
        cropperCfg: {
          professional_cover: {
            cropWidth: 225,
            cropHeight: 225,
            flexScale: [1, 1],
            MaxSize: 2,
            isShowHeadimgCalibration: true,
            uploadUrl: "",
          },
          other: {
            cropWidth: 300,
            cropHeight: 189,
            flexScale: [8.56, 5.4],
            MaxSize: 2,
            isShowHeadimgCalibration: false,
            uploadUrl: "",
          },
        },
        msg: {
          title: "提示",
          hide: true,
          align: "center",
        },
        titles: ["医师（住院医师）", "主治医师", "副主任医师", "主任医师"], // 职称列表
        citys: [],
        hideInfo: {
          phone: [0, -4],
          id_card_number: [0, -6],
          bank_number: [3, -3],
          defaultCfg: [8, -7],
        },
      },
      resetFile: true,
      selectKey: "",
      selectIndex: "",
      cropperManager: {
        key: "",
        url: "",
      },
      hideField: [
        "phone",
        "id_card_number",
        "bank_number",
        "id_card_reverse",
        "id_card_front",
      ],
      doctors: [],
      doctorInfo: {
        id: 0,
        professional_prove_img: [], // 职称资料
        openid: "",
        name: "", // 姓名
        hospital: "", // 医院
        department: "", // 科室
        phone: "", // 手机号
        job_name: "", //职称
        class_url: "", //课件/病例链接
        class_name: "", //课件/病例名
        province: "", // 省份
        city: "", // 城市
        job: "", //行政职务
        resume_academic: "", // 专家简历/学术任职
        professional_cover: "", // 简历图片
        id_card_number: "", // 身份证照片
        bank_province: "", // 银行卡信息
        bank_city: "", // 银行卡城市
        bank_name: "", // 银行
        bank_name_point: "", // 支行
        bank_number: "", // 银行卡号
        id_card_front: "", // 身份证人像面
        id_card_reverse: "", // 身份证国徽面
      },
      loading: false,
      showDoctorList: false,
      jobKeys: [
        "doctor_work_id_card",
        "professional_person",
        "professional_panoramic",
      ],
      notCut: ["professional_prove_img"],
      notImages: ["class_url"],
      query: {},
      IDCardHeight:"",
      cameraMask:"",
      isUploadIDCard:false,
      photoName:"id_card_front.jpg"
    };
  },
  async created() {
    this.query = this.$tools.getStorage("doctor-query") || this.$route.query;
    this.saveQuery();
    this.config.citys = await this.$tools.getCityConfig();
    this.config.banks = await this.$tools.getBankConfig();
  },
  beforeUnmount() {
    this.$tools.setStorage("doctor-query", "");
  },
  mounted() {
    this.login()
      .then(() => {
        this.id = this.query.id || "";
        if (this.id) {
          this.loadDoctorInfo();
        } else {
          this.doctorInfo = {
            ...this.doctorInfo,
            ...this.query,
          };
        }
      })
      .catch((err) => {
        this.$router.back();
      });
      this.getIDCardHeight();
  },
  computed: {
    provinces() {
      return this.config.citys.map((item) => item.name);
    },
    citys() {
      if (!this.doctorInfo.bank_province) return [];
      let index = this.provinces.indexOf(this.doctorInfo.bank_province);
      if (index == -1) return [];
      return this.config.citys[index].sub.map((item) => item.name);
    },
    bankCitys() {
      if (!this.doctorInfo.bank_province) return [];
      let index = this.provinces.indexOf(this.doctorInfo.bank_province);
      if (index == -1) return [];
      return this.config.citys[index].sub.map((item) => item.name);
    },
  },
  methods: {
    getIDCardHeight(){
      const height = this.$tools.getIDCardHeight(this.$refs.idCardFront.clientWidth)
      this.IDCardHeight = `height: ${height}px`;
    },
    async loadDoctorInfo() {
      let url = this.$tools.getURL(this.$urls.doctor.info, { ...this.query });
      this.$axios
        .get(url)
        .then((res) => {
          console.log(url);
          this.doctorInfo = {
            ...res.data,
            ...this.query,
            professional_prove_img: (res.data.professional_prove_img || "")
              .split(",")
              .filter((x) => x),
          };
          this.hideData();
          console.log(this.$tools.verifyDoctorInfo(this.doctorInfo));
          this.initScroll();
        })
        .catch(() => {});
    },
    initJobImg(data) {
      let images = [];
      this.jobKeys.forEach((key) => {
        images = images.concat(data[key]);
      });
      images = images.concat((data.professional_prove_img || "").split(","));
      images = images.filter((x) => x);
      this.doctorInfo.professional_prove_img = images;
    },
    isNeedUploadClass() {
      return Number(this.query.need_class);
    },
    isShowField(key) {
      return this.doctorInfo[key] && !this.doctorInfo[key].includes("*");
    },
    isShowUploaded(key) {
      return this.doctorInfo[key] && this.doctorInfo[key].includes("*");
    },
    changeNumber(key) {
      this.doctorInfo[key] = this.doctorInfo[key].replace(/[^\d*]/g, "");
    },
    changeIdNumber(key) {
      this.doctorInfo[key] = this.doctorInfo[key].replace(/[^\dxX*]/g, "");
    },
    changeProvince(key) {
      this.doctorInfo.bank_city = "";
    },
    //数据脱敏
    hideData() {
      for (let key of this.hideField) {
        this.doctorInfo[key] = this.doctorInfo[key] || "";
        if (!this.doctorInfo[key]) continue;
        let cfg = this.config.hideInfo[key] || this.config.hideInfo.defaultCfg;
        console.log(cfg, this.hideField, key);
        this.doctorInfo[key] = `${this.doctorInfo[key].slice(
          0,
          cfg[0]
        )}****${this.doctorInfo[key].slice(cfg[1])}`;
        console.log(this.doctorInfo[key]);
      }
    },
    getShowName(key, label) {
      return this.doctorInfo[key] ? "已上传" : label;
    },
    saveQuery() {
      this.$tools.setStorage("doctor-query", this.query);
    },
    selectIDCardWay(key){
      this.selectUploadIdCardWay(key).then(() => {
        //相机拍摄
        this.takeIDCard(key);
      }).catch((res)=>{
        if(res)return
        //相册选择
        if(key == "id_card_front"){
          this.frontIdCardExample().then(() => {
              this.selectFile(key)
            }).catch((err) => {
              this.selectFile(key)
          });
        }
        if(key == "id_card_reverse"){
          this.reverseIdCardExample().then(() => {
              this.selectFile(key)
            }).catch((err) => {
              this.selectFile(key)
          });
        }
      })
    },
    takeIDCard(key){
      this.selectKey = key;
      this.selectIndex = undefined;
      if(key == "id_card_front"){
        this.cameraMask = require('@/assets/images/camera/front.png');
        this.photoName = "id_card_front.jpg";
        this.$nextTick(() => {
          this.isUploadIDCard=true
        })
      }
      if(key == "id_card_reverse"){
        this.cameraMask=require('@/assets/images/camera/reverse.png');
        this.photoName = "id_card_reverse.jpg";
        this.$nextTick(() => {
          this.isUploadIDCard=true
        })
      }
    },
    saveIDCard(url){
      if(url){
        this.saveFileURL(url);
      }
      this.isUploadIDCard=false;
    },
    selectFile(key, index = undefined) {
      this.selectKey = key;
      this.selectIndex = index;
      this.$refs.selectFile.click();
    },
    getCropperCfg() {
      let key =
        this.selectKey == "professional_cover" ? "professional_cover" : "other";
      return this.config.cropperCfg[key];
    },
    async uploadFile(file) {
      let result = "";
      try {
        let img = await this.$tools.compressImage(file, true);
        let result = await uploads.uploadBase64({
          file: img,
          item: { type: "job" },
        });
        return result;
      } catch (err) {
        // 压缩失败
        let res = await uploads.uploadFile({
          file,
          key: "files",
          item: { type: "job" },
        });
        result = res.data[0];
        return result;
      }
    },
    async changeFile(event) {
      let file = event.target.files[0];
      if (!file) return;
      this.resetFile = false;
      this.$nextTick(() => {
        this.resetFile = true;
      });
      let loading = this.$tips.loading({ text: "上传中..." });
      // 处理非图片
      console.log(
        this.notImages.includes(this.selectKey),
        this.selectKey,
        this.notImages
      );
      if (this.notImages.includes(this.selectKey)) {
        await this.dealWithNotImage(file);
        loading.close();
        return;
      }
      // 处理图片
      let reg = "jpg|jpeg|png|PNG|JPG|JPEG";
      let RegObj = new RegExp(`^(${reg})$`);
      let type = file.name.split(".").slice(-1);
      if (!RegObj.test(type)) {
        this.$tips.error({ text: `类型必须是${reg.replace(/\|/g, ",")}` });
        loading.close();
        return "";
      }
      // 处理不需要剪切的
      if (this.notCut.includes(this.selectKey)) {
        await this.dealWithNotCutImage(file);
      } else {
        await this.dealWithCutImage(file);
      }
      loading.close();
    },
    async dealWithNotCutImage(file) {
      let url = await this.uploadFile(file);
      this.saveFileURL(url);
    },
    async dealWithNotImage(file) {
      let res = await uploads.uploadFile({
        file,
        type: "",
        reg: "",
        key: "files",
        item: { type: "couseware" },
      });
      console.log(file.name);
      this.doctorInfo.class_name = file.name.split(".").slice(0, -1).join(".");
      this.doctorInfo[this.selectKey] = res.data[0];
    },
    async dealWithCutImage(file) {
      let fileInfo = await this.$tools.compressImage(file, true);
      this.cropperManager.resetFile = false;
      this.cropperManager.url = fileInfo;
      this.$nextTick(() => {
        this.cropperManager.resetFile = true;
        this.$nextTick(() => {
          this.$refs.imageCropper.setData(this.cropperManager.url);
        });
      });
    },
    receiveData(data) {
      this.saveFileURL(data.url);
      this.cropperManager.url = "";
    },
    closeWin() {
      this.cropperManager.url = "";
      this.cropperManager.resetFile = true;
    },
    saveFileURL(url) {
      if (this.selectIndex !== undefined) {
        this.doctorInfo[this.selectKey][this.selectIndex] = url;
      } else {
        this.doctorInfo[this.selectKey] = url;
      }
    },
    checkData() {
      if (!this.doctorInfo.phone.includes("*")) {
        if (!this.doctorInfo.phone) {
          this.$tips.error({ text: "请输入手机号" });
          return false;
        }
        if (
          this.doctorInfo.phone &&
          !/^1[3-9]\d{9}$/.test(this.doctorInfo.phone)
        ) {
          this.$tips.error({ text: "请输入格式正确的手机号" });
          return false;
        }
      }
      if (!this.doctorInfo.id_card_number.includes("*")) {
        if (!this.doctorInfo.id_card_number) {
          this.$tips.error({ text: "请输入身份证号" });
          return false;
        }
        if (!/^\d{17}[\dxX]{1}$/g.test(this.doctorInfo.id_card_number)) {
          this.$tips.error({ text: "请输入格式正确的身份证号" });
          return false;
        }
      }
      if (!this.doctorInfo.id_card_front.includes("*")) {
        if (!this.doctorInfo.id_card_front) {
          this.$tips.error({ text: "请上传身份证人像面" });
          return false;
        }
      }
      if (!this.doctorInfo.id_card_reverse.includes("*")) {
        if (!this.doctorInfo.id_card_reverse) {
          this.$tips.error({ text: "请上传身份证国徽面" });
          return false;
        }
      }
      if (!this.doctorInfo.bank_name) {
        this.$tips.error({ text: "请选择银行" });
        return false;
      }
      if (!this.doctorInfo.bank_province) {
        this.$tips.error({ text: "请选择开户行所在省份" });
        return false;
      }
      if (!this.doctorInfo.bank_city) {
        this.$tips.error({ text: "请选择开户行所在城市" });
        return false;
      }

      if (!this.doctorInfo.bank_name_point) {
        this.$tips.error({ text: "请输入开户银行" });
        return false;
      }

      if (
        !this.doctorInfo.bank_number.includes("*") &&
        !/^\d{14,22}$/.test(this.doctorInfo.bank_number)
      ) {
        this.$tips.error({ text: "请输入正确的银行账号" });
        return false;
      }
      return true;
    },

    isHide(data) {
      return (String(data) || "").includes("*");
    },
    doCancel() {
      this.$router.back();
    },
    deleteDoctor() {
      if (this.loading) return;
      this.loading = true;
      MyPopup({
        content: [
          `您确定要删除此会议的专家<span style='color:red'>${this.doctorInfo.name}</span>吗`,
        ],
      })
        .then((res) => {
          let loading = this.$tips.loading({ text: "..." });
          let data = { ...this.query };
          data.doctor_id = data.id;
          this.$axios
            .patch(this.$urls.doctor.delete, data)
            .then((res) => {
              this.$tips.success({ text: "删除成功" });
              this.doCancel();
              setTimeout(() => {
                loading.close();
                this.loading = false;
              }, 1000);
            })
            .catch(() => {
              setTimeout(() => {
                loading.close();
                this.loading = false;
              }, 1000);
            });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    formatInfo() {
      let data = { ...this.doctorInfo };
      for (let key in data) {
        if (data[key] === null) data[key] = "";
      }
      data.professional_prove_img = data.professional_prove_img.join(",");
      return data;
    },
    //提交医生信息
    doCommit() {
      if (!this.checkData() || this.loading) return;
      this.loading = true;
      let loading = this.$tips.loading({ text: "信息保存中..." });
      this.$axios
        .patch(this.$urls.doctor.info, this.formatInfo())
        .then((res) => {
          setTimeout(() => {
            this.doctorInfo = {
              ...this.doctorInfo,
              ...res.data,
              id: res.data.doctor_id,
            };
            this.query = {
              ...this.query,
              ...res.data,
              id: res.data.doctor_id,
            };
            this.saveQuery();
            switch (res.code) {
              case 2002:
                this.doctorInfo.work_card_ocr_status = 0;
                MyPopup({
                  content: [
                    "职称证明<span style='color:red'>系统审核失败</span>，请检查<span style='color:red'>姓名</span>、<span style='color:red'>医院</span>、<span style='color:red'>科室</span>、<span style='color:red'>职称</span>文字信息是否与图片一致，确认后<span style='color:red'>重新上传</span>职称证明或者等待<span style='color:red'>人工审核通过</span>",
                  ],
                })
                  .then((res) => {
                    this.$router.push({
                      path: "/meetInfo",
                      query: {
                        id: this.$route.query.meet_id,
                      },
                    });
                  })
                  .catch((err) => {});
                break;
              case 2001:
                MyPopup({
                  content: [
                    "身份证信息<span style='color:red'>系统审核失败</span>，请检查<span style='color:red'>姓名</span>、<span style='color:red'>身份证号</span>等文字信息是否与图片一致，确认后<span style='color:red'>重新上传</span>身份证图片或者等待<span style='color:red'>人工审核通过</span>",
                  ],
                })
                  .then((res) => {
                    if (!this.$route.query.isJump) {
                      this.$router.push({
                        path: "/myMeet",
                      });
                    }
                  })
                  .catch((err) => {});
                break;
              default:
                this.$tips.success({ text: "修改成功" });
                if (this.$route.query.isJump == 2) {
                  this.$router.back();
                } else {
                  this.$router.back();
                }
            }
            loading.close();
            this.loading = false;
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            loading.close();
            this.loading = false;
          }, 1000);
        });
    },
    selectDoctor(doctor) {
      delete doctor.id;
      this.doctorInfo = {
        ...this.doctorInfo,
        ...doctor,
      };
      this.initJobImg(doctor);
      // this.hideData();
      this.showDoctorList = false;
    },
    //匹配基本信息
    getMatchList() {
      if (this.isMatching) return;
      this.isMatching = true;
      let loading = this.$tips.loading({ text: "匹配中..." });
      let url = this.$tools.getURL(this.$urls.doctor.match, {
        name: this.doctorInfo.name,
      });
      this.$axios
        .get(url)
        .then((res) => {
          setTimeout(() => {
            this.isMatching = false;
          }, 1000);
          loading.close();
          this.doctors = [...res.data].map((doctor) => {
            doctor.showName = `${doctor.name}-${doctor.hospital}`;
            return doctor;
          });
          this.showDoctorList = true;
        })
        .catch((err) => {
          setTimeout(() => {
            this.isMatching = false;
          }, 1000);
          loading.close();
        });
    },
  },
};
</script>
<style>
.doctor-labor-info-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  background: #fff;
}

.doctor-labor-info-title {
  height: 33px;
  background: var(--el-color-primary);
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}

.doctor-labor-info-main {
  padding: 0 20px;
}

.doctor-labor-info-block {
  margin-bottom: 15px;
  width: 100%;
}

.doctor-labor-info-block .el-button {
  width: 100%;
}

.doctor-labor-info-id-card-type .global-input {
  padding: 0 1rem;
}

.doctor-labor-info-key {
  font-weight: 700;
  font-size: 14px;
  color: #221815;
  line-height: 20px;
}

.doctor-labor-info-key span {
  /* color: #C00000; */
}

.doctor-labor-info-value {
  margin-top: 8px;
  height: auto;
  /* padding-right: 0.5rem; */
  display: flex;
  justify-content: space-between;
  color: #6a6266;
  word-break: break-all;
  position: relative;
}

.doctor-match-button {
  height: 23px;
  width: 91px;
  font-size: 13px;
  margin-right: 7px;
}

.doctor-match-icon {
  width: 13px;
  height: 13px;
  margin-right: 7px;
  margin-bottom: 2px;
}

.doctor-match-list {
  width: 100%;
  height: auto;
  position: absolute;
  right: 0;
  top: 45px;
  background: #fff;
  z-index: 1000;
  padding: 10px 10px 0;
  border: 1px solid #e5e5e5;
}

.doctor-match-title {
  color: var(--el-color-primary);
  font-size: 13px;
}

.doctor-match-list::before {
  content: "";
  width: 0;
  height: 0;
  border-width: 5px;
  border-color: transparent transparent #fff transparent;
  border-style: solid;
  position: absolute;
  right: 30px;
  top: -10px;
  z-index: 1001;
}

.doctor-match-ul {
  max-height: 80px;
  overflow: scroll;
}

.doctor-match-li {
  height: 20px;
  line-height: 20px;
  font-size: 13px;
}

.doctor-match-close-button {
  padding: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.doctor-match-close-button {
  width: 100%;
  height: 20px;
}

.doctor-match-close-button .customButton_container {
  width: 60px;
  font-size: 13px;
}

.doctor-labor-info-container .customButton_small {
  margin-top: 10px;
  width: auto;
  font-size: 13px;
}

.doctor-labor-info-container .el-textarea--inner {
  overflow: auto;
}

.doctor-labor-info-professional-cover {
  width: 109px;
  height: 109px;
  background: #e5e5e5;
}

.doctor-labor-info-professional-cover img {
  width: 77px;
  height: auto;
}

.doctor-labor-info-professional-cover-container {
  margin-top: 8px;
}

.doctor-job-select {
  display: flex;
  flex-direction: column;
}

.doctor-labor-info-select {
  border: 1px solid #e5e5e5;
  color: #9fa0a0;
  font-size: 13px;
  flex-direction: column;
  width: 100%;
  height: 194px;
  margin-bottom: 10px;
}

.doctor-labor-info-select span {
  margin-top: 8px;
}

.doctor-labor-info-select img {
  height: 18px;
  width: auto;
}

.doctor-submit-icon {
  height: 15px;
  width: auto;
  position: relative;
  z-index: 99999;
  margin-right: 6px;
  margin-top: -1px;
}

.doctor-labor-info-submit {
  margin-left: 10px;
}

.doctor-labor-info-class-block {
  font-size: 13px;
  text-decoration: underline;
  color: var(--el-color-primary);
}

/* .doctor-labor-info-class-block span:last-child{
  margin-left:10px;
} */
.doctor-labor-info-audit-status {
  font-size: 13px;
  color: #c00000;
  margin-bottom: 5px;
}
.doctor-labor-info-red {
  color: #c00000;
}
.doctor-labor-info-blue {
  color: var(--el-color-primary);
}

.doctor-labor-info-button-group {
  padding: 0 20px;
}
.doctor-labor-info-name-block {
  display: flex;
  align-items: center;
  width: 100%;
}
.doctor-labor-info-name-disabled {
  background: rgba(159, 160, 160, 0.1);
  font-size: 13px;
}
</style>